import * as React from "react";
import { TreeSelect } from "antd";
import { TreeSelectProps } from "antd/lib/tree-select";

interface AsyncTreeSelectProps<T> {
  treeData: TreeSelectProps<T>["treeData"];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  loadData: (nodeProps: any) => PromiseLike<any>; // Makes fetch request
  treeSelectProps?: TreeSelectProps<T>; // See Ant Tree component
  handleSelect?: (value: {}) => void; // Select Tree item trigger
  allowClear?: boolean;
}

export class AsyncTreeSelect<T> extends React.Component<AsyncTreeSelectProps<T>> {
  onSelect = (value) => {
    if (this.props.handleSelect) {
      this.props.handleSelect(value);
    }
  };

  onClear = () => this.props.handleSelect(null);

  onLoadData = async (nodeInfo) => {
    if (nodeInfo.subfolders) {
      return;
    }
    return await this.props.loadData(nodeInfo);
  };

  render() {
    return (
      <TreeSelect
        allowClear={this.props.allowClear}
        treeDataSimpleMode
        style={{ width: "100%" }}
        onSelect={this.onSelect}
        loadData={this.onLoadData}
        onClear={this.onClear}
        {...this.props.treeSelectProps}
        className="folder-icons"
        treeData={this.props.treeData}
      />
    );
  }
}
